import { HttpClient } from "@angular/common/http";
import { Injectable, Inject, Optional } from "@angular/core";
import { APIConfig } from "src/app/api";
import { Observable } from "rxjs";
import { PerfilService } from "../ajs-perfil.service";
import { CacheableGet } from "../profile/cacheable-get";
import { PROFILE_CACHE_TIME, FIVE_MINUTES_IN_MILLIS } from "../profile/consts";
import { tap } from "rxjs/operators";

export interface CompletionStatus {
  contatos: boolean;
  coletas: boolean;
  integracoes: boolean;
  finalizado: boolean;
}

@Injectable({
  providedIn: "root",
})
export class TutorialApiService {
  private getRequest: CacheableGet<CompletionStatus>;

  private get currentUserId() {
    const user = this.perfilService.getCacheUserData();

    return (user && user.id) || 0;
  }

  public get shouldUpdate() {
    return this.getRequest.shouldUpdate;
  }

  constructor(
    private http: HttpClient,
    private perfilService: PerfilService,
    private apiConfig: APIConfig,
    @Optional() @Inject(PROFILE_CACHE_TIME) cacheTime: number
  ) {
    if (!cacheTime) {
      cacheTime = FIVE_MINUTES_IN_MILLIS;
    }

    this.getRequest = new CacheableGet<CompletionStatus>(cacheTime, () =>
      this.http.get<CompletionStatus>(
        `${this.apiConfig.customerApiUrl}/clientes/${this.currentUserId}/primeiros-passos`
      )
    );
  }

  public getTutorialCompletion(): Observable<CompletionStatus> {
    return this.getRequest.get();
  }

  public setTutorialComplete(): Observable<CompletionStatus> {
    return this.http
      .post<CompletionStatus>(
        `${this.apiConfig.customerApiUrl}/clientes/${this.currentUserId}/primeiros-passos/finalizar`,
        {}
      )
      .pipe(
        tap(() => {
          this.getRequest.markForUpdate();
        })
      );
  }
}
